module.exports = __webpack_public_path__ + "static/42import-6e79fcfc1383100f7776a9ef9bc3e783.png";